import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

const PERFORM_WORKS_LIST_ITEM_ACTION = gql`
  mutation PerformWorksListItemAction(
    $id: ID!
    $input: PerformWorksListItemActionInput!
  ) {
    performWorksListItemAction(id: $id, input: $input) {
      worksListItem {
        id
        state
        rejectionReasonDescription
        rejectionDetails
        worksList {
          id
          completedItemsCount
          totalItemsCount
        }
      }
    }
  }
`;

type Params = {
  onFinished?: () => void;
};

export function useComplianceItemAction(params: Params) {
  return useMutation(PERFORM_WORKS_LIST_ITEM_ACTION, {
    onCompleted: (data) => {
      if (!data || !data.performWorksListItemAction) return;
      createMessage('success', 'Compliance status successfully changed');
      params?.onFinished?.();
    },
    onError: () => {
      createMessage(
        'error',
        'Failed to change compliance state. Please try again.'
      );
      params?.onFinished?.();
    },
    refetchQueries: [
      'PaginatedWorksListItems',
      'CandidateAssignmentQueryComplianceTabQuery',
      'ComplianceItemDrawerQuery',
      'ComplianceItemDrawerFilesTabQuery',
      'ComplianceItemUpsertDrawerV2Query',
    ],
  });
}
